import { createSelector } from 'reselect';
import constants from '../../../common/constants/CommonConstants';
import { canUserEditEntity } from '../../../common/util/authUtils';
import { selectLoggedInUser } from '../userSelector';

const accounts = (state) => state.accounts.list;
const accountsStats = (state) => state.accounts.statbarData;

const enrichWithEditPermissionCheck = (accountList, loggedInUser) => {
  const { roleName: role, userId } = loggedInUser;
  return accountList.map((account) => {
    const canCurrentUserEditEntity = canUserEditEntity(
      account.owners,
      userId,
      role
    );
    return {
      ...account,
      canCurrentUserEditEntity,
    };
  });
};

const accountSelector = createSelector(
  accounts,
  selectLoggedInUser,
  enrichWithEditPermissionCheck
);

export const accountsPartialListSelector = createSelector(
  (state) => state.entityPartialList.list[constants.ACCOUNT_LEVEL],
  selectLoggedInUser,
  enrichWithEditPermissionCheck
);

export const accountsStatsSelector = createSelector(
  accountsStats,
  (stats) => stats
);

export default accountSelector;

const listPageData = (state) => state.accounts.listPageData;
export const listPageDataSelector = createSelector(
  listPageData,
  (data) => data
);
